<section class="xl:container xl:m-auto xl:pl-[15px] xl:pr-[15px]" id="aboutauthor">
    <div class="p-6 md:px-[70px] md:py-12 bgbanner bg-cover bg-center bg-[#F5F1F1]">
        <h3 class="text-32 text-black font-libre-regular mb-6">
            About the Author
        </h3>
        <div class="flex mb-6">
            <div>
                <h4 class="text-18 text-black mb-[6px]">Nidhi Agrawal</h4>
                <p class="text-14 text-[#666666] mb-0">
                    Executive Director & Business Head (West) – Client Relations
                </p>
            </div>
        </div>
        <p class="text-14 md:text-16 text-black mb-0">
            With 22 years in financial services, Nidhi Agrawal has led initiatives in wealth management and
            priority banking. She has been part of Kotak Mahindra Bank’s founding team and held leadership roles at
            Infosys, Axis Burgundy, and SALT. She is especially passionate about creating pathways for women in finance.
        </p>
    </div>
</section>